import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ChipField,
  BulkDeleteWithConfirmButton,
} from "react-admin";
import GlobalPagination from "../common/GlobalPagination";

import customerFilters from "./customerFilters";

const CustomerList = () => (
  <List
    sort={{ field: "name", order: "ASC" }}
    filters={customerFilters}
    perPage={GlobalPagination.perPage}
    pagination={GlobalPagination.pagination}
  >
    <Datagrid
      rowClick="show"
      bulkActionButtons={
        <BulkDeleteWithConfirmButton mutationMode="pessimistic" />
      }
    >
      <TextField source="name" />
      <TextField source="contactPerson" />
      <TextField source="crmId" />
      <ChipField source="domainCount" textAlign="center" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);
export default CustomerList;
